var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('n8n-select',{attrs:{"size":"small"},on:{"change":_vm.botChange},model:{value:(_vm.selectedBot),callback:function ($$v) {_vm.selectedBot=$$v},expression:"selectedBot"}},_vm._l((_vm.botList),function(bot){return _c('n8n-option',{key:bot.botName,attrs:{"label":bot.botName,"value":bot._id}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }